import React, { useContext, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';


const CnpAddCollageImagePopup = () => {

  const {
    setCnpSelectedPhotoVideo, 
    
    showCnpAddCollageImagePopup, setShowCnpAddCollageImagePopup,
    setShowCnpSelectCollagePopup,
    setShowCnpCollagePopup,
    selectedCollageSetting,
    selectedCollageImages,
    handleClickCollageBox,
    collageInputRef,
    handleChangeCollageFile,
  } = useContext(ApiContext);


  // handle convert collage to blob file
  const handleConvertCollageToBlob = async () => {
    const { width, height, layout } = selectedCollageSetting;
  
    const canvasWidth = parseFloat(width) * 10;
    const canvasHeight = layout.map((_, i) => parseFloat(height[i]) * 10).reduce((a, b) => a + b, 0);
  
    const canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const ctx = canvas.getContext('2d');
  
    let currentY = 0;
    let imageIndex = 0;
  
    for (let rowIndex = 0; rowIndex < layout.length; rowIndex++) {
      const cols = layout[rowIndex];
      const rowHeight = parseFloat(height[rowIndex]) * 10;
      const colWidth = canvasWidth / cols;
  
      for (let colIndex = 0; colIndex < cols; colIndex++) {
        const imgUrl = selectedCollageImages[imageIndex];
        const x = colIndex * colWidth;
        const y = currentY;
  
        // White background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(x, y, colWidth, rowHeight);
  
        // Border
        ctx.strokeStyle = 'black';
        ctx.lineWidth = 2;
        ctx.strokeRect(x, y, colWidth, rowHeight);
  
        if (imgUrl) {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.src = imgUrl;
  
          await new Promise((resolve) => {
            img.onload = () => {
              ctx.drawImage(img, x, y, colWidth, rowHeight);
              resolve();
            };
            img.onerror = resolve;
          });
        }
  
        imageIndex++;
      }
  
      currentY += rowHeight;
    }
  
    // Create file and update state (no return)
    canvas.toBlob((blob) => {
      const file = new File([blob], 'collage.png', { type: 'image/png' });
  
      setCnpSelectedPhotoVideo((prevState) => {
        const updated = [...prevState];
        if (!updated[0]) return prevState;
  
        updated[0] = {
          ...updated[0],
          file,
        };
  
        return updated;
      });
    }, 'image/png');
  };

  // handle click next 
  const handleClickNext = () => {
    setShowCnpAddCollageImagePopup(false);
    setShowCnpCollagePopup(true);
  };

  // handle close add collage image popup
  const handleCloseAddCollageImagePopup = () => {
    setShowCnpAddCollageImagePopup(false);
    setShowCnpSelectCollagePopup(true);
  };


  useEffect(() => {
    if (selectedCollageImages.length > 0 && selectedCollageImages.every(img => img !== null)) {
      // console.log('All images selected!');
      
      handleConvertCollageToBlob();

      // remove/clear tags
      setCnpSelectedPhotoVideo(preState => {
        const updated = [...preState];
  
        if (updated[0]) {
          updated[0] = {
            ...updated[0],
            tags: [],
          };
        };
  
        return updated;
      });
    };
  }, [selectedCollageImages]);


  return (
    <>
      <Modal show={showCnpAddCollageImagePopup} onHide={handleCloseAddCollageImagePopup} centered backdrop="static" keyboard={false} className="main-modal" >
        <Modal.Header className="mb-3 pt-0" closeButton>
          <h5 className="flex-grow-1 text-center pt-3 mb-0">Collage</h5>
        </Modal.Header>

        <Modal.Body className="pt-1">
          {/* Collage */}
          <div className='border rounded-4 py-3 bg-light d-flex align-items-center justify-content-center my-3'>
            {
              (selectedCollageSetting) 
              &&
              <div className='position-relative' style={{ width: `${parseFloat(selectedCollageSetting.width) * 10}px`, border: '1px solid #555' }} >
                {
                  selectedCollageSetting.layout.map((cols, rowIndex) => {

                    const rowHeight = `${parseFloat(selectedCollageSetting.height[rowIndex]) * 10}px`;

                    return (
                      <div className="d-flex" style={{ height: rowHeight }} key={rowIndex}>
                        {Array(cols).fill(0).map((_, colIndex) => {

                          const index = selectedCollageSetting.layout.slice(0, rowIndex).reduce((a, b) => a + b, 0) + colIndex;

                          const image = selectedCollageImages[index];

                          return (
                            <div className="border border-dark d-flex align-items-center justify-content-center cursor-pointer" onClick={() => handleClickCollageBox(index)} key={colIndex}
                              style={{ height: rowHeight, width: `${parseFloat(selectedCollageSetting.width) * 10}px` }}
                            >
                              {
                                image 
                                ? 
                                <img src={image} className="object-fit-fill h-100 w-100" alt="collage-img" />
                                : 
                                <img src="/images/icons/add-circle.svg" style={{ height: '20px', width: '20px' }} alt="add" />
                              }
                            </div>
                          );
                        })}
                      </div>
                    );
                  })
                }
              </div>
            }
          </div>

          <input ref={collageInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleChangeCollageFile} />

          <button type="button" className='btn btn-primary rounded-pill w-100' onClick={handleClickNext}
            disabled={selectedCollageImages.some(img => img === null)}
          >Next</button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CnpAddCollageImagePopup;